import { BottomSheet, SignIn, SignInProps } from '@/components'

interface SignInModalProps extends Partial<SignInProps> {
  isShown: boolean
}

export function SignInModal({ isShown }: SignInModalProps) {
  return (
    <BottomSheet header="Mission Control - Log In" isVisible={isShown} onClose={() => {}} showClose={false}>
      <div className="mx-auto max-w-120 px-6">
        <SignIn />
      </div>
    </BottomSheet>
  )
}
